import router from "@/router";
import store from "@/store/store";
import axios from 'axios';

export default function setup() {


    axios.interceptors.response.use(
        (response) => {
            return response;
        },
        error => {
            // handle error
            if (error.response) {
                let errorUrl = error.response.config.url
                if (errorUrl.includes('units/login')) {  //login call failed

                    store.dispatch("Logout").then(() => {
                        router.push('/portal/unauthorized')
                    })

                    return new Promise((resolve, reject) => {
                        reject(error);
                    });
                }
                else if (error.response.status === 401 ) { //got 401 on not "login call, try logging in again and getting a new token.
                        return store.dispatch('RefreshAuthToken').then(() => {
                            error.config.headers['Authorization'] = store.getters.getJwtAuthenticationToken;
                            error.config.baseURL = undefined;
                            if(store.getters.getIsLoggedIn) {
                                return axios.request(error.config);
                            }else{
                                return Promise.reject(error)
                            }
                        })
                } else if (error.response.status === 409 || error.response.status === 422 || error.response.status === 404 || error.response.status === 400
                || error.response.status === 500) {
                    return Promise.reject(error) // the calling classes care about 422 and 409, so send these back
                }
                console.log("Unexpected error on the method call: " + error.response.data.message)

            } else if (error.request) {
                console.log(error.request.data.message)
                return Promise.reject(error);
            } else {
                console.log(error.request.data.message)
            }
        });
}

